'use client';

import { useApp } from '@/context/AppContext';

const content = {
  fr: {
    kicker: '01',
    title:  'Profil',
    desc:   'Qui je suis et ce que je fais.',
    p1:     "Étudiant en Mastère Cybersécurité, je me forme aux techniques offensives depuis deux ans. Passionné par la sécurité, j'explore les systèmes via HackTheBox, des projets Red Team et du développement d'outils offensifs.",
    fbTitle: 'Identité',
    rows: [
      { dt: 'Statut',       dd: 'Étudiant en alternance' },
      { dt: 'Formation',    dd: 'Mastère Cybersécurité' },
      { dt: 'Lieu',         dd: 'France' },
    ],
  },
  en: {
    kicker: '01',
    title:  'About',
    desc:   'Who I am and what I do.',
    p1:     "Cybersecurity Master's student, training in offensive techniques for over two years. Security-focused, I explore systems through HackTheBox, Red Team projects and offensive tooling.",
    fbTitle: 'Identity',
    rows: [
      { dt: 'Status',      dd: 'Apprentice student' },
      { dt: 'Training',    dd: "Master's in Cybersecurity" },
      { dt: 'Location',    dd: 'France' },
    ],
  },
};

const Profil = () => {
  const { language } = useApp();
  const c = content[language];

  return (
    <section className="section" id="profil">
      <div className="shell">
        <div className="section-head">
          <div>
            <div className="kicker"><span className="ix">{c.kicker}</span> {c.title}</div>
            <h2>{c.title}</h2>
          </div>
          <p className="desc">{c.desc}</p>
        </div>

        <div className="profil">
          <div className="profil-prose">
            <p className="lead">{c.p1}</p>
          </div>

          <aside className="factbox">
            <h4>{c.fbTitle}</h4>
            <dl>
              {c.rows.map((row, i) => (
                <div key={i} className="row">
                  <dt>{row.dt}</dt>
                  <dd>{row.acc ? <b>{row.dd}</b> : row.dd}</dd>
                </div>
              ))}
            </dl>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default Profil;
